export const exhibitionOptions = [
  { label: 'Exibir proprietário', name: 'boExibirProprietario' },
  { label: 'Exibir acessibilidade', name: 'boExibirAcessibilidade' },
  { label: 'Exibir situação', name: 'boExibirSituacao' },
];

export const licenseStatusOptions = [
  { label: 'Válidas', value: 1 },
  { label: 'Vencidas', value: 2 },
  { label: 'Ambas', value: 3 },
];

export const groupingByOptions = [
  {label: "Sem agrupamento", value: null},
  {label: "Agrupar por setor", value: 6},
  {label: "Agrupar por tipo de licença", value: 7},
  {label: "Agrupar por analista", value: 8},
  {label: "Agrupar por operador", value: 9},
  {label: "Agrupar por proprietário", value: 10},
]
